import { useContext } from 'react';
import ThemeContext from './theme-context';

/**
 * Provides the current `ThemeContext` to the component.
 */
export default function useThemeContext() {
  return useContext(ThemeContext);
}
